import cx from 'classnames'
import React from 'react'
import * as styles from '../styles/components/ribbon.module.scss'
import { RibbonBlok } from '../utils/storyblok'
import { renderRichText } from 'gatsby-source-storyblok'

interface RibbonProps extends React.HTMLAttributes<HTMLDivElement> {
    data: RibbonBlok
}

const Ribbon = (props: RibbonProps) => {
    const { className, data } = props

    const style =  {
        backgroundColor: data.backgroundColor ?? '#000',
        color: data.textColor ?? '#fff',
    }

    const body = renderRichText(data.text)

    return (
        <a href={data.url} style={style} className={cx(styles.ribbon, className)}>
            { data.text &&
                <span className={styles.text} dangerouslySetInnerHTML={{ __html: body }} />
            }
            { data.image &&
                <img src={data.image.filename} alt={data.image.alt} className={styles.image} />
            }
        </a>
    )
}

export default Ribbon
